import { IFunusSettings } from 'modules/settings/models/IFunusSettings';

export const emptyFunusSettings: IFunusSettings = {
  flowersMail: {
    automationMailFlowersDelay: 15,
    automationMailFlowersEnabled: false,
  },
  whatsapp: {
    authToken: '',
    sourceNumberPhone: '',
    templateName: '',
  },
};
